import { legacyApiAuth, wiggotAPI } from '@wiggot/apis'
import type {
  IPassMinimumFields,
  IResponseService,
  IUserResponse
} from '../../interfaces/src'

export const getPassMinimumFields = async (): Promise<
  IResponseService<IPassMinimumFields>
> => {
  try {
    const response = await legacyApiAuth.get<any>(
      '/v2.0.2/user/pass_required_info'
    )
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postActiveTrialPlan = async (): Promise<IResponseService<any>> => {
  try {
    const response = await legacyApiAuth.post<any, any>(
      '/v2.0.2/advanced/trial',
      {}
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getPersistKey = async (
  key: string
): Promise<IResponseService<any>> => {
  try {
    const response = await legacyApiAuth.get<any>(`/v2.0.2/persist/key/${key}`)
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postSendPersistKey = async (
  data: any
): Promise<IResponseService<any>> => {
  try {
    const response = await legacyApiAuth.post<any, any>('/v2.0.2/persist', data)
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getVerifyAccount = async (
  verificationCode: string
): Promise<IResponseService<any>> => {
  try {
    const response = await legacyApiAuth.get<any>(
      `/v2.0.2/user/verify/${verificationCode}`
    )
    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getUserInfo = async (
  isAdmin: boolean,
  roles: any
): Promise<IResponseService<IUserResponse>> => {
  try {
    const response = await legacyApiAuth.get<IUserResponse>('/v2.0.2/user', {
      params: {
        isAdmin,
        roles
      }
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const patchUpdateProfile = async (
  data: any
): Promise<IResponseService<any>> => {
  const response = await legacyApiAuth.patch<any, any>(
    `/v2.0.2/user/profile`,
    data
  )

  try {
    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postSendUpdatePlanMessage = async ({
  userId,
  subject = '',
  comments
}: {
  userId: number
  subject?: string
  comments?: string
}): Promise<IResponseService<any>> => {
  try {
    const response = await wiggotAPI.post<any, any>(
      '/advance/user/store-support-message',
      {
        userId,
        subject,
        comments: comments === '' ? undefined : comments
      }
    )
    if (response) {
      return {
        isSuccess: true,
        data: response
      }
    }
    return {
      isSuccess: false,
      error: 'not found data resources'
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
